import React, { useState } from "react";
import { Navigate, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/authContext";
import { doCreateUserWithEmailAndPassword } from "../../../firebase/auth";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../Auth.css";

const Register = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isRegistering, setIsRegistering] = useState(false);

  const { userLoggedIn } = useAuth();

  const onSubmit = async (e) => {
    e.preventDefault();

    // Reset the error message

    // Validate password and confirm password
    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    if (!isRegistering) {
      setIsRegistering(true);
      await doCreateUserWithEmailAndPassword(email, password)
        .then((userCredential) => {
          navigate("/home");
        })
        .catch((error) => {
          const errorCode = error.code;
          let message = "";

          console.log(error);
          switch (errorCode) {
            case "auth/email-already-in-use":
              message = "This email is already in use. Please try login.";
              break;
            case "auth/invalid-email":
              message = "Invalid email address. Please enter a valid email.";
              break;
            case "auth/weak-password":
              message =
                "Password is too weak. Please enter a stronger password.";
              break;
            case "auth/operation-not-allowed":
              message = "Account creation is currently disabled.";
              break;
            default:
              message = "An error occurred. Please try again.";
          }
          toast.error(message);
          setIsRegistering(false);
        });
    }
  };

  return (
    <>
      {userLoggedIn && <Navigate to="/home" replace={true} />}

      <main className="container">
        <div className="form-container">
          <h3 className="title">Create a New Account</h3>

          <form onSubmit={onSubmit} className="form">
            <div className="form-control">
              <label className="label">Email</label>
              <input
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input"
              />
            </div>
            <div className="form-control">
              <label className="label">Password</label>
              <input
                disabled={isRegistering}
                type="password"
                autoComplete="new-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input"
              />
            </div>
            <div className="form-control">
              <label className="label">Confirm Password</label>
              <input
                disabled={isRegistering}
                type="password"
                autoComplete="off"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="input"
              />
            </div>

            <button type="submit" disabled={isRegistering} className="button">
              {isRegistering ? "Signing Up..." : "Sign Up"}
            </button>

            <div className="form-footer">
              Already have an account?
              <Link to="/login" className="link">
                Login
              </Link>
            </div>
          </form>
        </div>
      </main>

      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default Register;
